import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { FocusZone } from '@fluentui/react/lib/FocusZone';
import { useClockPayload } from '../hooks/useClockPayload';
import TimeZoneView from './TimeZoneView';

export default observer(function TimeZonesView() {
    const payload = useClockPayload();
    return (
        <FocusZone>
            {payload.timeZones.map((timeZone, index) => {
                return (
                    <TimeZoneView
                        key={`${timeZone.timeZoneId}-${index}`}
                        timeZoneInfo={timeZone}
                        index={index}
                    />
                );
            })}
        </FocusZone>
    );
});
